module.exports = {
  // tag页标签-操作-中文的配置
  tagsView: {
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  logpage: require('./logPage').zh,
  // 系统设置
  stsytemset: require('./stsytemset').zh,
  // tag-标签
  route: require('./route').zh.route,
  // 左侧菜单
  moduleIndexMenu: require('./moduleIndexMenu').zh.moduleIndexMenu,
  // 职工管理
  staffManament: require('./staffManagement').zh.staffManament,
   //家长管理
   parentsManagement: require('./parentsManagement').zh,
  //报名招生
  enrollAndRecruit: require('./enrollAndRecruit').zh,

  //连锁管理
  gardenManage:require('./gardenManage').zh,
  //通知管理
  notificationManagement:require('./notificationManagement').zh,
  studentManage:require('./studentManage').zh,
  daily:require('./daily').zh,
  attendance:require('./attendance').zh,
  recipe: require('./recipe').zh,
  paymentManagement: require('./paymentManagement').zh,
  videoMonitoring: require('./videoMonitoring').zh,
  courseManagement: require('./courseManagement').zh,
  messageCenter: require('./messageCenter').zh,
  // 官网新闻更新
  websiteNewsUpdate: require('./websiteNewsUpdate').zh,
  qa: require('./QA').zh,
}



// WEBPACK FOOTER //
// ./src/components/i18n/lang/cn.js